"use strict";
// * Weird capitalization is straight from the Hyundai doc. (* where noted)
Object.defineProperty(exports, "__esModule", { value: true });
exports.HyundaiVCategories = void 0;
exports.HyundaiVCategories = {
    "New": "new",
    "Used": "used",
    "Certified Used": "CPO",
};
